module.exports = __webpack_public_path__ + "img/gallery-image-14.93d1b7b5.jpg";